/**
 * Shared Inventory UI constants - prevents UI drift between pages.
 */

export const INVENTORY_INPUT_CLASS =
  'w-full min-w-[140px] border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white';

export const INVENTORY_ERROR_BOX_CLASS =
  'p-4 bg-red-50 border border-red-200 rounded-lg';

export const INVENTORY_LOADING_TEXT = 'جاري تحميل البيانات...';

export function inventoryEmptyText(entityArabic: string): string {
  return `لا توجد ${entityArabic}`;
}
